module.exports = __webpack_public_path__ + "img/arrow_right_alt.b7bebf19.svg";